module.exports = __webpack_public_path__ + "static/img/working.8e4f567.png";


//////////////////
// WEBPACK FOOTER
// ./static/working.png
// module id = EfPn
// module chunks = 0